import {
  BoxStyleProps,
  Button,
  Center,
  Icon,
  Text,
} from '@frontend/ui-library';

import { ReactComponent as ExternalLinkSvg } from '@frontend/icons/external-link-2.svg';
import { ReactComponent as PlusCircleSvg } from '@frontend/icons/plus-circle.svg';

import { links } from '../../../../constants';
import { getIdFromUrl } from '@frontend/utils';

type Page = 'currencySelection' | 'networkSelection';

interface PaymentOptionSuggestionsProps extends BoxStyleProps {
  className?: string;
  page: Page;
}

export default function PaymentOptionSuggestions({
  className,
  page,
  ...boxStyleProps
}: PaymentOptionSuggestionsProps): JSX.Element {
  const title = page === 'currencySelection' ? '' : 'Can’t find your network?';

  const firstLink = links.getCurrencyNetworkSurveyLink(getIdFromUrl());
  const firstLinkText = 'Suggest new currency or network';

  const secondLinkText =
    page === 'currencySelection'
      ? 'check accepted currencies'
      : 'check accepted networks';

  const secondLink =
    page === 'currencySelection'
      ? links.support.SUPPORTED_CURRENCIES_NETWORKS
      : links.support.SUPPORTED_CURRENCIES_NETWORKS;

  return (
    <Center direction="column" className={className} {...boxStyleProps}>
      {title && (
        <Text align="center" size="small" color="neutral-600" mb="8">
          {title}
        </Text>
      )}
      <Button
        as="a"
        fullWidth
        size="medium"
        variant="ghost"
        href={firstLink}
        target="_blank"
        rel="noopener noreferrer"
        rightIcon={
          <Icon
            size={16}
            fillWithCurrentColor={false}
            component={<PlusCircleSvg />}
          />
        }
      >
        {firstLinkText}
      </Button>
      <Button
        as="a"
        fullWidth
        href={secondLink}
        target="_blank"
        rel="noopener noreferrer"
        size="medium"
        variant="ghost"
        rightIcon={
          <Icon
            size={16}
            fillWithCurrentColor={false}
            component={<ExternalLinkSvg />}
          />
        }
      >
        {secondLinkText}
      </Button>
    </Center>
  );
}
